var React = require('react');

function IconPlus (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Plus icon"),React.createElement("desc",{"key":1},"Plus icon"),React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(1 1)","key":2},[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#FFF","stroke":"#DAE7F0","key":0}),React.createElement("path",{"stroke":"#3F7BAB","d":"M16.571 10.143v11.71M22.429 16h-11.71","key":1})])]);
}

IconPlus.displayName = "IconPlus";

IconPlus.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","role":"img"};

module.exports = IconPlus;

IconPlus.default = IconPlus;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./app/javascript/images/icons/icon-plus.svg
// module id = 924
// module chunks = 0 2